import Img from "react-image";

import React, { Component } from "react";
import loading from "../../../images/loading.gif";
import "./loading_image.scss";
import missingImageURL from "../../../images/missing.png";

class LoadingImage extends Component {
  render() {
    const imageSrcs = [this.props.src || this.props.imageURL, missingImageURL];
    return (
      <Img
        className={"loading-image " + this.props.className}
        src={imageSrcs}
        loader={
          <img
            alt="Loading..."
            src={loading}
            className={"loading-image__loader " + this.props.className}
          />
        }
        alt={this.props.alt || ""}
      />
    );
  }
}

export default LoadingImage;
